/** Widget の siteId（アナリティクス用。認可には使われない） */
export const DIGITANE_VIDEO_SITE_ID = 'robcratch'
/** オープニング動画はチュートリアルミッションの seq 0 のチャプター */
export const OPENING_CHAPTER_SEQ = 0
/**
 * 初期化（embed.js の読み込みの開始）からこの時間（ミリ秒）たっても、
 * オープニングの再生が始まらなければ先へ進むボタンを出す。
 * embed.js の読み込みが止まる場合や、Widget の中の再生エラーは親へ通知されない
 * ため。読み込みが終わって Widget を埋め込んだ時点では数え直さない
 */
export const OPENING_START_TIMEOUT_MS = 15000
/** embed.js のパス（配信元オリジン直下） */
export const DIGITANE_VIDEO_EMBED_PATH = '/embed.js'
/**
 * embed.js の読み込み（script の挿入から load / error まで）がこの時間（ミリ秒）で
 * 終わらなければ失敗として扱い、次の呼び出しで読み込み直せるようにする。
 * 応答もエラーも返らないまま止まっても、止まった Promise を返し続けないため
 */
export const DIGITANE_VIDEO_EMBED_TIMEOUT_MS = 15000
/**
 * init（iframe の挿入）からこの時間（ミリ秒）たっても、その Widget から最初の
 * イベント（video:ready など）が届かなければ、Widget が起動しなかったとして
 * iframe を破棄し、読み込みの失敗として扱う。iframe の HTML や起動用の JS を
 * 取得できないと、Widget からは何も通知されないため。最初のイベントが届いた後は
 * 監視しない（Widget の中の取得の打ち切りと再読み込みは Widget が行う）
 */
export const DIGITANE_VIDEO_START_TIMEOUT_MS = 15000

/** VITE_DIGITANE_VIDEO_URL を正規化して返す（末尾スラッシュ除去。未設定・空なら null） */
export const getDigitaneVideoUrl = (): string | null => {
  const value: unknown = import.meta.env.VITE_DIGITANE_VIDEO_URL
  if (typeof value !== 'string') return null

  const normalized = value.trim().replace(/\/+$/, '')
  return normalized === '' ? null : normalized
}
